import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('basic-tooltip', () => import(/* webpackMode: "lazy" */'./basic-tooltip'));
